export const authEndpointConfig = {
	baseUrl: 'api/v1/auth',
	tokenExchangeUrl: (): string => `${authEndpointConfig.baseUrl}/login`,
	logoutUrl: (): string => `${authEndpointConfig.baseUrl}/logout`
}